import ReactDOM from "react-dom/client";
import "./index.css";
import Theme from "./theme";
import React, { Suspense, lazy } from "react";
import {
	HashRouter as Router,
	Route,
	Routes,
	Navigate,
} from "react-router-dom";
import { ConfigProvider, theme } from "antd";
import plPL from "antd/es/locale/pl_PL";
import dayjs from "dayjs";
import "dayjs/locale/pl";
import { AuthProvider } from "./context/AuthContext";
import AppLayout from "./components/Layout";
import AccessDenied from "./components/AccessDenied";
import Idle from "./components/Idle";
import PrivateRoute from "./components/PrivateRoute";
import Przelewy from "./views/Przelewy";
import Wygenerowane from "./views/Wygenerowane";
import Przekazy from "./views/Przekazy";
import PrzekazyWygenerowane from "./views/PrzekazyWygenerowane";
import Pozyczki from "./views/Pozyczki";
import { PaginationProvider } from "./context/PaginationContext";
import { PaginationProviderPrzelewy } from "./context/PaginationContextPrzelewy";
import { PaginationProviderPrzekazy } from "./context/PaginationContextPrzekazy";
import { PaginationProviderRezerwy } from "./context/PaginationContextRezerwy";
import { PaginationProviderBezPrzekazania } from "./context/PaginationContextBezPrzekazania";
import { WplywProvider } from "./context/wplywContext";
import { SettingsProvider } from "./context/settingsContext";
import Wplyw from "./views/Wplyw";
import { ActiveTabProvider } from "./context/activeTabContext";
import { SocketProvider } from "./context/socketContext";
import { BlockedRowsProvider } from "./context/BlockedRowsContext";
import Rezerwy from "./views/Rezerwy";
import { RezerwaProvider } from "./context/rezerwaContext";
import Rezerwa from "./views/Rezerwa";
import WplywyBezPrzekazania from "./views/WplywyBezPrzekazania";
import Ustawienia from "./views/Ustawienia";
const Wplywy = lazy(() => import("./views/Wplywy"));

const root = ReactDOM.createRoot(document.getElementById("root"));

dayjs.locale("pl");
const App = () => {
	return (
		<AuthProvider>
			<SettingsProvider>
				<SocketProvider>
					<PaginationProvider>
						<ConfigProvider
							locale={plPL}
							theme={Theme(theme)}
						>
							<Idle />
							<Router>
								<Suspense fallback={<div>Ładowanie...</div>}>
									<Routes>
										<Route
											path="/wplywy"
											element={
												<PrivateRoute>
													<BlockedRowsProvider>
														<AppLayout
															content={<Wplywy />}
														/>
													</BlockedRowsProvider>
												</PrivateRoute>
											}
										/>
										<Route
											path="/wplywy-bez-przekazania"
											element={
												<PrivateRoute>
													<BlockedRowsProvider>
														<PaginationProviderBezPrzekazania>
															<AppLayout
																content={
																	<WplywyBezPrzekazania />
																}
															/>
														</PaginationProviderBezPrzekazania>
													</BlockedRowsProvider>
												</PrivateRoute>
											}
										/>
										<Route
											path="/wplywy/:wplywid"
											element={
												<PrivateRoute>
													<WplywProvider>
														<ActiveTabProvider>
															<AppLayout
																content={
																	<Wplyw />
																}
															/>
														</ActiveTabProvider>
													</WplywProvider>
												</PrivateRoute>
											}
										/>
										<Route
											path="/przelewy"
											element={
												<PrivateRoute>
													<PaginationProviderPrzelewy>
														<AppLayout
															content={
																<Przelewy />
															}
														/>
													</PaginationProviderPrzelewy>
												</PrivateRoute>
											}
										/>
										<Route
											path="/przekazy"
											element={
												<PrivateRoute>
													<PaginationProviderPrzekazy>
														<AppLayout
															content={
																<Przekazy />
															}
														/>
													</PaginationProviderPrzekazy>
												</PrivateRoute>
											}
										/>
										<Route
											path="/rezerwy"
											element={
												<PrivateRoute>
													<PaginationProviderRezerwy>
														<AppLayout
															content={
																<Rezerwy />
															}
														/>
													</PaginationProviderRezerwy>
												</PrivateRoute>
											}
										/>
										<Route
											path="/rezerwy/:rezerwaid"
											element={
												<PrivateRoute>
													<RezerwaProvider>
														<AppLayout
															content={
																<Rezerwa />
															}
														/>
													</RezerwaProvider>
												</PrivateRoute>
											}
										/>
										<Route
											path="/wygenerowane"
											element={
												<PrivateRoute>
													<PaginationProviderPrzelewy>
														<AppLayout
															content={
																<Wygenerowane />
															}
														/>
													</PaginationProviderPrzelewy>
												</PrivateRoute>
											}
										/>
										<Route
											path="/przekazy-wygenerowane"
											element={
												<PrivateRoute>
													<PaginationProviderPrzekazy>
														<AppLayout
															content={
																<PrzekazyWygenerowane />
															}
														/>
													</PaginationProviderPrzekazy>
												</PrivateRoute>
											}
										/>
										<Route
											path="/pozyczki"
											element={
												<PrivateRoute>
													<AppLayout
														content={<Pozyczki />}
													/>
												</PrivateRoute>
											}
										/>
										<Route
											path="/ustawienia-systemu"
											element={
												<PrivateRoute>
													<AppLayout
														content={<Ustawienia />}
													/>
												</PrivateRoute>
											}
										/>
										<Route
											path="/access/denied"
											element={<AccessDenied />}
										/>
										<Route
											path="*"
											element={<Navigate to="/wplywy" />}
										/>
									</Routes>
								</Suspense>
							</Router>
						</ConfigProvider>
					</PaginationProvider>
				</SocketProvider>
			</SettingsProvider>
		</AuthProvider>
	);
};

root.render(App());
